import React from 'react';

export const AsqHeader: React.FC = () => {
  return (
    <header className='w-full border-b border-gray-200 bg-white'>
      <div className='mx-auto max-w-6xl px-3 py-2 flex items-center justify-between'>
        <div className='text-xs sm:text-sm md:text-base text-gray-800 font-semibold'>
          Ages & Stages Questionnaires® ASQ®-3
        </div>
        <img src='/asq-assets/asq3-logo.jpg' alt='ASQ-3 logo' className='h-6 md:h-8 w-auto' />
      </div>
    </header>
  );
};

export const AsqFooter: React.FC = () => {
  return (
    <footer className='w-full border-t border-gray-200 bg-white'>
      <div className='mx-auto max-w-6xl px-3 py-3 text-[11px] leading-relaxed text-gray-700 whitespace-pre-line'>
        {`Ages & Stages Questionnaires®, Third Edition (ASQ®-3), Squires & Bricker. © 2009 and Japanese translation © 2024 Paul H. Brookes Publishing Co., Inc. With permission of Paul H. Brookes Publishing Co., Inc.
／ Ages & Stages Questionnaires®, 第 3 版 (ASQ®-3), Squires & Bricker. 2009 日本語訳 © 2024 Paul H. Brookes Publishing Co. Paul H. Brookes Publishing Co., Inc. の許可を得て掲載．`}
      </div>
    </footer>
  );
};

export default AsqHeader;
